import { render, staticRenderFns } from "./SecureSearch.vue?vue&type=template&id=322fb94d&"
import script from "./SecureSearch.vue?vue&type=script&lang=js&"
export * from "./SecureSearch.vue?vue&type=script&lang=js&"
import style0 from "./SecureSearch.vue?vue&type=style&index=0&id=322fb94d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports